module.exports = __webpack_public_path__ + "img/empty-receive-nft.e67a7c19.svg";